import { deepFreeze } from 'utils/deepFreeze';
import { FavouritesExperienceState } from 'redux/modules/favourites-experience/types';

export const initialState: Readonly<FavouritesExperienceState> = deepFreeze({});
